import React from 'react';
import { Badge } from '@/components/ui/badge';
export const WinnerBlock = ({ winner, itemName }) => {
    return (<div className="rounded-md border p-4 bg-primary/5">
            <div className="flex items-center justify-between gap-3">
                <div className="text-sm font-medium">Top {itemName}</div>
                <Badge variant="secondary" className="bg-primary/10 text-primary border-primary/20">
                    Winner
                </Badge>
            </div>

            <div className="text-sm mt-1">
                <span className="font-medium">
                    {winner.label} · {winner.publicId}
                </span>
                <span className="text-muted-foreground">
                    {' '}
                    — {winner.scans} scans · {winner.uniqueVisitors} unique · {winner.share}%
                </span>
            </div>
        </div>);
};
WinnerBlock.displayName = 'WinnerBlock';
